<template>
  <div id="Benefits">
    <div class="bg bg-top" />
    <div class="bg bg-bottom" />
    <div class="player">
      <img src="@/assets/images/benefits/benefits-player.png" />
    </div>
    <b-container>
      <div class="content">
        <div class="title">
          <img src="@/assets/images/faq/lightning-bolt-red.png" />
          Incentives
        </div>
        <div class="accordion-container">
          <div class="accordion_wrapper" v-if="purl.accounts">
            <Accordion
              :accordionTitle="'What renewal incentive options do I have?'"
              :isOpen="true"
            >
              <p>
                Your Pistons ONE membership entitles you to select one of the
                following incentives:
              </p>
              <ul>
                <li
                  v-for="(item, index) in incentives(
                    purl.accounts[0].incentiveSegment
                  )"
                  :key="'incentive' + index"
                >
                  {{ item }}
                </li>
              </ul>
              <a
                class="incentiveButton"
                :href="incentiveLink"
                target="_blank"
                @click="
                  store.dispatch('purl/purlTracking', 'Select Incentives')
                "
                >select incentives</a
              >
            </Accordion>
            <Accordion
              :accordionTitle="'What if I choose to opt out of auto-renewal?'"
            >
              <p>
                By opting out of auto-renewal you acknowledge that you are
                forfeiting your current seat locations for the 2022-23 NBA
                Season and that you will not be entitled to any renewal
                incentives. To opt out, you must complete the cancellation form
                and speak directly with your Membership Experience
                representative.
              </p>
              <a
                class="incentiveButton"
                href="https://palace.tfaforms.net/920"
                target="_blank"
                @click="store.dispatch('purl/purlTracking', 'Opt Out')"
                >opt out</a
              >
            </Accordion>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";
import Accordion from "@/components/Accordion";

export default {
  name: "Benefits",
  components: { Accordion },
  setup() {
    const store = useStore();

    // State
    const state = reactive({
      purl: computed(() => store.getters["purl/getAccount"]),
    });

    return { ...toRefs(state), store };
  },
  data() {
    return {
      incentiveLink: "",
    };
  },
  methods: {
    incentives(segment) {
      let incentiveList = null;
      switch (segment) {
        case "SEGMENT 1":
          incentiveList = [
            "Invite for 2 to Summer League in Las Vegas",
            "Commemorative Pistons Custom Shinola Watch",
            "Commemorative Pistons Remix Sneakers",
            "Round of Golf at Wabeek",
            "Invite for 2 to Away Game - Flight, Hotel, Dinner, Game Tickets",
            "$300 DoorDash Credit",
          ];
          this.incentiveLink = "https://palace.tfaforms.net/914";
          break;
        case "SEGMENT 2":
          incentiveList = [
            "Commemorative Pistons Custom Shinola Watch",
            "Commemorative Pistons Remix Sneakers",
            "Round of Gold at Wabeek",
            "$250 DoorDash Credit",
          ];
          this.incentiveLink = "https://palace.tfaforms.net/924";
          break;
        case "SEGMENT 3":
          incentiveList = [
            "Commemorative Pistons Custom Shinola Watch",
            "Round of Golf at Wabeek",
            "Access to STM Media Day",
            "$200 DoorDash Credit",
          ];
          this.incentiveLink = "https://palace.tfaforms.net/925";
          break;
        case "SEGMENT 4":
          incentiveList = [
            "Pistons Jersey with corresponding player autograph session",
            "Regional Away Game Bus Trip for 2",
            "$200 DoorDash Credit",
            "Access to STM Media Day",
            "Double Rewards Points",
          ];
          this.incentiveLink = "https://palace.tfaforms.net/926";
          break;
        case "SEGMENT 5":
          incentiveList = [
            "Pistons Jersey with corresponding player autograph session",
            "Regional Away Game Bus Trip for 2",
            "Access to STM Media Day",
            "$100 DoorDash Credit",
            "Double Rewards Points",
          ];
          this.incentiveLink = "https://palace.tfaforms.net/927";
          break;
        case "SEGMENT 6":
          incentiveList = [
            "Access to player autograph session",
            "Regional Away Game Bus Trip for 2",
            "$100 DoorDash Credit",
            "Access to STM Media Day",
            "Double Rewards Points",
          ];
          this.incentiveLink = "https://palace.tfaforms.net/928";
          break;
        case "SEGMENT 7":
          incentiveList = [
            "Access to player autograph session",
            "Access to STM Media Day",
            "$75 DoorDash Credit",
            "Double Rewards Points",
          ];
          this.incentiveLink = "https://palace.tfaforms.net/929";
          break;
        case "SEGMENT 8":
          incentiveList = [
            "Access to player autograph session",
            "Access to STM Media Day",
            "$75 DoorDash Credit",
            "Double Rewards Points",
          ];
          this.incentiveLink = "https://palace.tfaforms.net/930";
          break;
        case "SEGMENT 9":
          incentiveList = [
            "Access to player autograph session",
            "Access to STM Media Day",
            "$50 DoorDash Credit",
            "Double Rewards Points",
          ];
          this.incentiveLink = "https://palace.tfaforms.net/931";
          break;
      }
      return incentiveList;
    },
  },
};
</script>

<style lang="scss" scoped>
#Benefits {
  position: relative;
  height: 100vh;
  width: 100%;
  background: url("~@/assets/images/benefits/bg-texture.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  @media (min-width: 992px) {
    background-attachment: fixed;
  }
  @media (max-width: 992px) {
    display: flex;
    flex-direction: column-reverse;
    height: fit-content;
    padding-top: 115px;
  }
  .bg {
    position: absolute;
    left: 0;
    background: url("~@/assets/images/benefits/checkers.png");
    background-size: cover;
    background-repeat: no-repeat;
    height: 67px;
    width: 100%;
    &-top {
      top: 0;
    }
    &-bottom {
      bottom: 0;
    }
  }
  .player {
    position: absolute;
    bottom: 0;
    left: 0;
    height: calc(100% - 77px);
    object-fit: contain;
    z-index: 2;
    @media (max-width: 992px) {
      position: relative;
      height: auto;
      width: 100%;
      margin-top: 10px;
      padding-right: 24px;
    }
    img {
      height: 100%;
      object-fit: contain;
      @media (max-width: 992px) {
        height: calc(100vh - 84px);
      }
      @media (max-width: 710px) {
        height: auto;
        width: 100%;
      }
    }
  }
  .container {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    z-index: 3;
    @media (max-width: 767px) {
      max-width: 100vw;
    }
    &.accordion-container {
      @media (max-width: 500px) {
        max-width: 100vw;
        padding: 0;
      }
    }
    .content {
      width: calc(50% - 22px);
      @media (max-width: 992px) {
        width: 100%;
      }
      .title {
        position: relative;
        font-family: Birdrockers;
        font-weight: normal;
        font-size: 52px;
        line-height: 52px;
        letter-spacing: normal;
        color: #ffffff;
        margin-bottom: 34px;
        @media (max-width: 767px) {
          font-size: 42px;
          line-height: 42px;
        }
        @media (max-width: 400px) {
          font-size: 37px;
          line-height: 37px;
        }
        img {
          position: absolute;
          top: 0;
          left: -90px;
          width: 77px;
          object-fit: contain;
          @media (max-width: 992px) {
            position: relative;
            left: auto;
            top: auto;
          }
          @media (max-width: 767px) {
            width: 66px;
          }
        }
      }
    }
  }
}
</style>